<!-- Info Message -->

<div
  *ngIf="!showProcessing && !showStepError && !showStepFail && !showStepAlert"
  class="d-flex vstack align-items-center text-center mt-64"
>
  <div class="mb-16">
    <img src="/assets/icones/vermelho/flag.svg" alt="" width="80" />
  </div>
  <h2 class="mb-16">Vamos corrigir seu arquivo</h2>

  <div class="w-50 mb-32">
    <p class="font-size-18 mb-0">
      Encontramos alguns erros no seu arquivo. Não se preocupe, vamos ajudá-lo a corrigir e completar sua importação
    </p>

    <!-- <a href="#" (click)="onLinkClick(); $event.preventDefault()" data-target="#myModal">{{ linkText }}</a> -->
  </div>

  <button mat-flat-button (click)="irParaCorrecao()">Continuar</button>
</div>

<!-- Processing / Loading -->
<div class="mt-48" *ngIf="showProcessing">
  <div *ngIf="!checked" class="row justify-content-center">
    <div class="col-lg-4 rounded-16 background p-3">
      <div class="text-start d-flex align-items-center justify-content-between gap-3">
        <div>
          <h6 class="mb-0">Validando arquivo</h6>
          <p class="mb-0">Estamos verificando a validade de seu CSV</p>
        </div>
        @if (isChecking) {
          <div class="spinner-border spinner-border-md color-brand-principal" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        } @else {
          <div>
            <mat-icon
              class="d-flex align-items-center justify-content-center color-green"
              svgIcon="checked-current"
            ></mat-icon>
          </div>
        }
      </div>
    </div>
  </div>
  <div *ngIf="!isChecking" class="row justify-content-center mt-2">
    <div class="col-lg-4 rounded-16 background p-3">
      <div class="text-start d-flex align-items-center justify-content-between gap-3">
        @if (!showStepError && !showStepFail) {
          <div>
            <h6 class="mb-0">Processando arquivo</h6>
            <p class="mb-0">Processando as informações do seu CSV</p>
          </div>
        } @else {
          <div>
            <h6 class="mb-0">Carregando informações</h6>
            <p class="mb-0">Processando os dados da sua importação</p>
          </div>
        }

        <div class="spinner-border spinner-border-md color-brand-principal" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Inconsistency Error -->
<div class="row" *ngIf="showStepError && !showProcessing && !showStepAlert">
  <div class="d-flex justify-content-between align-items-center">
    <spe-titulo-sessao titulo="Correção de células" [icone]="'assets/icones/cinza/row.svg'">
      <a
        href="mailto:atendimento.beneficios@semparar.com.br?subject=Dúvidas - Importação de dados dados APB (arquivo padrão de benefícios)"
      >
        Veja um vídeo explicativo
      </a>
    </spe-titulo-sessao>

    @if (errorsToShow.length > 0) {
      <div class="hstack gap-2 mt-48 mb-24">
        <!-- Active filter chips -->
        <mat-chip-set class="rounded-mat-chip" aria-label="Filtros ativos" *ngIf="activeFilters().length">
          <mat-chip *ngFor="let filter of activeFilters()" [removable]="true" (removed)="clearFilter(filter.key)">
            {{ getFilterLabel(filter.key, filter.value) }}
            <mat-icon class="color-brand-principal" matChipRemove>close</mat-icon>
          </mat-chip>
        </mat-chip-set>

        <!-- Search bar -->
        <spe-table-search-bar
          [(inputValue)]="inputValue"
          [(showSearchBar)]="showSearchBar"
          (applySearchFilter)="applySearchFilter()"
        />

        <!-- Column filter menu -->
        <spe-table-filter-menu [filtersCount]="activeFilters().length">
          <ng-template #filterContent>
            <form [formGroup]="filtersForm">
              <section>
                <h6 class="mb-8">Coluna com erro</h6>
                <mat-radio-group formControlName="column" (change)="errorIndex.set(-1)">
                  <ul class="list-unstyled">
                    <li>
                      <mat-radio-button [value]="null">Todas</mat-radio-button>
                    </li>
                    <li *ngFor="let col of errorColumnsComputed()">
                      <mat-radio-button [value]="col.campo">
                        {{ col.label }}
                        <span class="badge background-brand-5 color-brand-2 rounded-pill ms-1">
                          {{ col.count }} / {{ col.countTotal }}
                        </span>
                      </mat-radio-button>
                    </li>
                  </ul>
                </mat-radio-group>
              </section>
            </form>
          </ng-template>
          <ng-template #filterFooter>
            <button (click)="clearAllFilters()" mat-flat-button class="w-100">Limpar filtros</button>
          </ng-template>
        </spe-table-filter-menu>
      </div>
    }
  </div>

  @if (errorsToShow.length > 0) {
    <div class="rounded-3 p-0 m-0 flex-grow-1">
      <cdk-virtual-scroll-viewport
        [itemSize]="ROW_HEIGHT"
        [style.height.px]="viewportHeight()"
        class="table-viewport table-responsive table-fixed-head"
      >
        <table class="table table-sm table-hover font-size-12 table-bordered align-middle p-0 m-0">
          <thead>
            <tr class="table-light">
              <th class="text-end p-2" [attr.id]="0">#</th>
              <th *ngFor="let col of columns" class="max-column-250 text-nowrap text-truncate p-2">
                {{ col }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *cdkVirtualFor="let row of filteredRows(); trackBy: trackByLinha">
              <th scope="row" class="text-end p-2">
                {{ row.numeroLinha }}
              </th>
              <td
                *ngFor="let cell of row._enrichedCells; trackBy: trackByCell(row.numeroLinha)"
                class="expanding-input-container p-2"
                [class.inner-border-error]="cell.error && !(cell.errorId | isEdited: editedIds())"
                [class.inner-border-primary]="cell.errorId | isEdited: editedIds()"
                [class.table-danger]="cell.error && !(cell.errorId | isEdited: editedIds())"
                [class.table-primary]="cell.errorId | isEdited: editedIds()"
                [attr.id]="cell.errorId"
                (focusin)="onErrorFocus($event)"
              >
                <div class="d-flex align-items-center justify-content-between">
                  <textarea
                    [(ngModel)]="cell.valor"
                    type="text"
                    class="form-control-plaintext expanding-input"
                    rows="1"
                    [readonly]="!cell.error"
                    (change)="onCellBlur(cell, row)"
                    (keydown)="onCellKeydown($event, cell, row)"
                  ></textarea>
                  <button
                    mat-icon-button
                    class="commit-btn"
                    [hidden]="!cell.error"
                    (click)="onCellBlur(cell, row)"
                    matTooltip="Confirmar valor (clique aqui ou pressione Enter)"
                  >
                    <mat-icon>keyboard_return</mat-icon>
                  </button>
                  <mat-icon
                    class="color-error d-flex align-items-center justify-content-center info-mat-icon"
                    [matTooltip]="cell.error?.mensagemErro"
                    [hidden]="!cell.error || (cell.errorId | isEdited: editedIds())"
                    svgIcon="info-vermelho"
                  >
                  </mat-icon>
                  <mat-icon
                    class="text-primary font-size-18 d-flex align-items-center justify-content-center"
                    [matTooltip]="'Campo editado - Erro corrigido:' + (cell.error?.mensagemErro ?? '')"
                    [hidden]="!(cell.errorId | isEdited: editedIds())"
                  >
                    draft_orders
                  </mat-icon>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </cdk-virtual-scroll-viewport>
    </div>

    <div class="d-flex justify-content-end gap-3 mt-3">
      <button mat-button (click)="prevError()" [disabled]="isFirstError()" [disableRipple]="true">
        <mat-icon class="me-2" svgIcon="arrow-back-current"></mat-icon> Erro anterior
      </button>
      <button mat-button (click)="nextError()" [disabled]="isLastError()" [disableRipple]="true">
        Próximo erro<mat-icon iconPositionEnd class="ms-2 pe-none" svgIcon="arrow-next-current"></mat-icon>
      </button>
    </div>
  } @else {
    <div>
      <p class="font-size-18 mb-0">
        Não foram encontrados erros nas células, mas a importação não pôde ser concluída. Entre em contato com a central
        de atendimento para resolver essa questão.
      </p>
      <div class="text-center mt-16">
        <button mat-stroked-button (click)="eventNewImport.emit()">Importar novo arquivo</button>
      </div>
    </div>
  }
</div>

<!-- Fail -->
<div class="row" *ngIf="showStepFail && !showProcessing && !showStepAlert">
  <spe-titulo-sessao titulo="Relacionamento de colunas" [icone]="'assets/icones/cinza/column.svg'">
    <a
      href="mailto:atendimento.beneficios@semparar.com.br?subject=Dúvidas - Importação de dados dados APB (arquivo padrão de benefícios)"
    >
      Veja um vídeo explicativo
    </a>
  </spe-titulo-sessao>
  <div>
    <div class="row">
      <div class="col-4">
        <b class="font-size-16">Coluna no seu arquivo</b>
      </div>
      <div class="col-4">
        <b class="font-size-16">Coluna que esperamos</b>
      </div>
    </div>
    <div class="row mt-16 mb-8" *ngFor="let column of columnsNotIdentified; let i = index">
      <div class="col-4 d-flex align-items-center gap-3">
        <div class="background rounded-16 flex-grow-1 p-3">{{ column }}</div>
        <mat-icon class="d-flex align-items-center" svgIcon="arrow-right-2-vermelho"></mat-icon>
      </div>
      <div class="col-4 d-flex align-items-center gap-3">
        <mat-form-field class="mb-0">
          <mat-label>Selecione uma coluna</mat-label>
          <mat-select
            placeholder="Selecione a coluna"
            class="w-100"
            [(ngModel)]="columnSelections[i]"
            [disabled]="getState(i) !== 'editing'"
          >
            <mat-select-trigger>{{ columnSelections[i] }}</mat-select-trigger>
            <mat-option *ngFor="let option of getAvailableOptions(i)" [value]="option">
              {{ option }}
              <span *ngIf="isRequired(option)" class="badge background-brand-5 color-brand-2 rounded-pill ms-1"
                >Obrigatório</span
              >
            </mat-option>
          </mat-select>

          <!-- Default: arrow down -->
          <mat-icon *ngIf="getState(i) === 'editing'" matSuffix class="color-brand-principal">
            keyboard_arrow_down
          </mat-icon>

          <!-- Confirmed: check icon -->
          <mat-icon *ngIf="getState(i) === 'confirmed'" matSuffix svgIcon="checked-colorido"></mat-icon>

          <!-- Ignored: close icon -->
          <mat-icon *ngIf="getState(i) === 'ignored'" matSuffix svgIcon="close-vermelho"></mat-icon>
        </mat-form-field>
      </div>
      <div class="col-4 d-flex align-items-center gap-3">
        <!-- Editing state: Confirmar + Ignorar -->
        <ng-container *ngIf="getState(i) === 'editing'">
          <button mat-button [disabled]="!columnSelections[i]" (click)="confirmarTroca(i)">Confirmar troca</button>
          <button mat-button [disabled]="isRequiredSelected(i)" (click)="ignorar(i)">Ignorar</button>
        </ng-container>

        <!-- Confirmed/Ignored state: Editar -->
        <button mat-button *ngIf="getState(i) !== 'editing'" (click)="editar(i)">Editar</button>
      </div>
    </div>
  </div>
</div>

<!-- Alert -->
<div class="row mt-48 justify-content-center" *ngIf="showStepAlert && !showStepError && !showStepFail">
  <div class="d-flex vstack align-items-center text-center">
    <div class="rounded-circle mb-24">
      <img [src]="'/assets/icones/vermelho/error.svg'" alt="" width="80" />
    </div>
    <h2 class="mb-16">{{ alertTitle || 'Algo deu errado' }}</h2>

    <div class="font-size-18 column-450 mb-32">
      <p class="mb-0 break-lines">
        {{ alertMessage }}
        @if (alertMessage) {
          <a
            href="mailto:atendimento.beneficios@semparar.com.br?subject=Dúvidas - Importação de dados dados APB (arquivo padrão de benefícios)"
          >
            Central de Atendimento
          </a>
        }

        @if (alertError && alertMessage) {
          e informe o erro: <b>"{{ alertError }}"</b>
        }
        @if (alertError && !alertMessage) {
          Ocorreu um erro: <b>"{{ alertError }}"</b>
        } @else {
          .
        }
      </p>
    </div>

    <ng-content></ng-content>
    <button mat-flat-button (click)="eventNewImport.emit()">Importar novo arquivo</button>
  </div>
</div>
